module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "fm2"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "afmtx1"
  }, [_c('div', {
    staticClass: "ctag1"
  }, [_vm._v("In memory, we find the most complete release from the narrowness of presented time and place.... The picture is one of human beings confronted by a world in which they can be masters only as they ... discover ways of escape from the complete sway of immediate circumstances.")]), _vm._v(" "), _c('div', [_c('br')]), _c('div', {
    staticClass: "ctag1"
  }, [_vm._v("—F. C. Bartlett, "), _c('i', [_vm._v("Remembering")])]), _vm._v(" "), _c('div', [_c('br')]), _c('div', [_c('br')]), _c('div', {
    staticClass: "ctag1"
  }, [_vm._v("What did you learn in school today, dear"), _c('br'), _vm._v(" little boy of mine?"), _c('br'), _vm._v(" What did you learn in school today, dear"), _c('br'), _vm._v(" little boy of mine?"), _c('br'), _vm._v(" I learned that war is not so bad"), _c('br'), _vm._v(" I learned about the great ones we have had"), _c('br'), _vm._v(" We fought in Germany and in France"), _c('br'), _vm._v(" And I am someday to get my chance"), _c('br'), _vm._v(" That’s what I learned in school today"), _c('br'), _vm._v(" That’s what I learned in school.")]), _vm._v(" "), _c('div', [_c('br')]), _c('div', {
    staticClass: "ctag1"
  }, [_vm._v("—A song by Tom Paxton")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d72ce5a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stud_9781595587596_oeb_fm2_r1.vue
// module id = 72
// module chunks = 0